import { PhoneFrame } from "@/components/marketing";
import { cn } from "@/lib/utils";
import type { CampaignExample } from "../../../../data";
import { campaignAccentClasses } from "../../campaignAccent.util";

interface SmsMockProps {
  campaign: CampaignExample;
  subtitle: string;
  time: string;
}

// The campaign as a text message from the business's sender ID.
const SmsMock = ({ campaign, subtitle, time }: SmsMockProps) => {
  const accent = campaignAccentClasses[campaign.accent];
  return (
    <PhoneFrame contentClassName="flex flex-col text-ink">
      <div className="grid grid-cols-[auto_auto_1fr] items-center gap-x-2 border-b border-border bg-muted px-3 pt-1 pb-2.5">
        <span
          aria-hidden="true"
          className="row-span-2 text-[1.8rem] leading-none text-tone-sky-ink"
        >
          ‹
        </span>
        <span
          aria-hidden="true"
          className={cn(
            "row-span-2 grid size-[34px] place-items-center rounded-full font-extrabold text-white",
            accent.solid,
          )}
        >
          {campaign.brand.initial}
        </span>
        <b className="text-[13px] tracking-[0.04em]">{campaign.brand.smsSender}</b>
        <small className="text-[11px] text-ink-muted">{subtitle}</small>
      </div>
      <div className="grid flex-1 content-start gap-2.5 bg-white p-3">
        <small className="text-center text-[11px] text-ink-muted">{time}</small>
        <div className="max-w-[92%] rounded-[18px_18px_18px_4px] bg-border px-3 py-2.5">
          <p className="text-[13px] leading-[1.4] break-words">{campaign.sms}</p>
        </div>
      </div>
    </PhoneFrame>
  );
};

export default SmsMock;
